import saveAs from './file-saver.js'

export function download(request, next) {
    if (!request.download) {
        return next(request)
    }

    return next({
        ...request,
        respType: 'blob',
    }).then((result) => {
        if (!request.download || !(result instanceof Blob)) {
            return result
        }
        const headers = result.resp?.headers

        if (request.download) {
            let fileName
            if (typeof request.download === 'string') {
                fileName = request.download
            } else {
                const ContentDisposition =
                    headers?.get('Content-Disposition') ?? headers?.get('content-disposition') ?? '; filename='

                fileName = ContentDisposition.split(';')[1]?.split('filename=')[1]
                if (!fileName?.trim()) {
                    const fileNameUnicode = ContentDisposition.split('filename*=')[1]
                    if (fileNameUnicode) {
                        //当存在 filename* 时，取filename* 并进行解码（为了解决中文乱码问题）
                        fileName = decodeURIComponent(fileNameUnicode.split('"')[1])
                    }
                }
            }
            saveAs(result, fileName)
        }
        return result
    })
}
